import { DATE_AND_TIME } from '@shared/utils/constants';
import { formatDate } from '@client/utils/formatDate';
import { EditableDetailsItem } from '@client/components/EditableField';

type CounterpartyItemsInput = {
	name: string;
	companyName: string | null;
	address: string | null;
	city: string | null;
	country: string | null;
	phoneNumberOffice: string | null;
	phoneNumberMobile: string | null;
	email: string | null;
	invoiceAddress: string | null;
	invoicePhoneNumber: string | null;
	invoiceEmail: string | null;
	createdAt: Date;
	updatedAt: Date;
	exportCode?: string | null;
};

const getItems = <Values, >({
	name,
	companyName,
	address,
	city,
	country,
	phoneNumberOffice,
	phoneNumberMobile,
	email,
	invoiceAddress,
	invoicePhoneNumber,
	invoiceEmail,
	createdAt,
	updatedAt,
	exportCode,
}: CounterpartyItemsInput): EditableDetailsItem<Values>[] => [
	{
		key: 'name',
		label: 'Internal name',
		value: name,
		type: 'text',
		editable: true,
	},
	{
		key: 'companyName',
		label: 'Full Company name',
		value: companyName,
		type: 'text',
		editable: true,
	},
	{
		key: 'address',
		label: 'Address',
		value: address,
		type: 'text',
		editable: true,
	},
	{
		key: 'city',
		label: 'City',
		value: city,
		type: 'text',
		editable: true,
	},
	{
		key: 'country',
		label: 'Country',
		value: country,
		type: 'text',
		editable: true,
	},
	{
		key: 'phoneNumberOffice',
		label: 'Office phone number',
		value: phoneNumberOffice,
		type: 'text',
		editable: true,
	},
	{
		key: 'phoneNumberMobile',
		label: 'AOH phone number',
		value: phoneNumberMobile,
		type: 'text',
		editable: true,
	},
	{
		key: 'email',
		label: 'Email',
		value: email,
		type: 'text',
		editable: true,
	},
	{
		key: 'invoiceAddress',
		label: 'Invoice address',
		value: invoiceAddress,
		type: 'text',
		editable: true,
	},
	{
		key: 'invoicePhoneNumber',
		label: 'Invoice phone number',
		value: invoicePhoneNumber,
		type: 'text',
		editable: true,
	},
	{
		key: 'invoiceEmail',
		label: 'Invoice email',
		value: invoiceEmail,
		type: 'text',
		editable: true,
	},
	{
		key: 'exportCode',
		label: 'Excel Export Code',
		value: exportCode ?? null,
		type: 'text',
		editable: true,
	},
	{
		key: 'createdAt',
		label: 'Creation date',
		value: formatDate(createdAt),
	},
	{
		key: 'updatedAt',
		label: 'Last updated',
		value: formatDate(updatedAt, DATE_AND_TIME),
	},
];

export default getItems;
